import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  useColorModeValue,
  useToast,
  Flex,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  VStack
} from "@chakra-ui/react";
import { cqAPI, getBid, getParam } from "../../lib/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import moment from "moment/moment";
import CustomizeAiHistoryHeader from "./CustomizeAIHistoryHeader";
import { useNavigate } from "react-router-dom";


const CustomizeAIHistoryList = () => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const [history, setHistory] = useState([]);
  const toast = useToast();
  const bgBoxColor = useColorModeValue("#ffffff", '#212330');
  const navigate = useNavigate();
  const assisted = getParam('assisted')

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await cqAPI.get("/settings/ai/history?assisted=1");
        if (response.type === "ok") {
          setHistory(response?.data || []);
          console.log(response?.data);
        }
      } catch (error) {
        console.error("Error loading the history:", error);
        toast({
          title: "Error",
          description: "Something Went Wrong! please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    fetchHistory();
  }, []);

  const restoreVersion = async (historyId) => {
    try {
      const response = await cqAPI.put("/settings/ai/restore/?id=" + historyId);
      if (response.type === "ok") {
        console.log(response?.msg);
        toast({
          title: "Success",
          description: response?.msg || "AI settings restored successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate(`/settings/customize-ai/?bid=${getBid()}`);
      }
    } catch (error) {
      console.error("Error restoring the history:", error);
      toast({
        title: "Error",
        description: "Something Went Wrong! please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }

  return (
    <Box m={4} px={4} width="100%" height="100%" overflowY="auto" backgroundColor={bgBoxColor} borderRadius="8px">
      <CustomizeAiHistoryHeader assisted={assisted}/>
      <VStack
        spacing={2}
        align='stretch'
        ml={4}
      >
        {history.map((item, index) => {
          return <Box ali key={index} p={1} bgColor={bgColor} borderRadius="md" width="full">
            <Flex flexDirection="row" alignItems="center" width="100%">
              <Text align="start" fontSize="sm" ml={2} my={2}>
                Updated: {moment(item.created).format("MMMM D, YYYY h:mm a")}
              </Text>
              <Flex justifyContent="flex-end" gap={2} ml='auto' my={1} mr={2} minHeight="40px" alignItems="center">
                <Menu flexBasis="5%">
                  <MenuButton as={IconButton}
                              aria-label="Options"
                              icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                              variant="ellipsis"/>
                  <MenuList>
                    {/*TODO*/}
                    <MenuItem onClick={() => {
                      assisted ?
                        navigate(`/settings/customize-ai/history/${item._id}?bid=${item.bid}&assisted=1`)
                        : navigate(`/settings/customize-ai/history/${item._id}?bid=${item.bid}`)
                    }}>
                      View
                    </MenuItem>
                    {!assisted &&
                      <MenuItem onClick={() => restoreVersion(item._id)}>
                        Restore this version
                      </MenuItem>
                    }
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>
          </Box>
        })}
      </VStack>
    </Box>
  )
};

export default CustomizeAIHistoryList;
